import React from "react";
import CreatableSelect from "react-select/creatable";
import FormActions from "../../../components/Form/FormActions";

interface SelectOption {
  value: string;
  label: string;
}

interface CardapioFormProps {
  nome: string;
  ingredientes: string[];
  tipo: "doce" | "salgada";
  fotoUrl?: string | null;
  isSaving: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
  onNomeChange: (nome: string) => void;
  onIngredientesChange: (ingredientes: string[]) => void;
  onTipoChange: (tipo: "doce" | "salgada") => void;
  onFotoChange: (foto: File | null) => void;
  onRemoverFoto: () => void;
}

const CardapioForm: React.FC<CardapioFormProps> = ({
  nome,
  ingredientes,
  tipo,
  fotoUrl,
  isSaving,
  onSubmit,
  onCancel,
  onNomeChange,
  onIngredientesChange,
  onTipoChange,
  onFotoChange,
  onRemoverFoto,
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Nome do sabor
        </label>
        <input
          type="text"
          value={nome}
          onChange={(event) => onNomeChange(event.target.value)}
          className="w-full rounded-md border border-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Ex: CALABRESA PAULISTA"
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Tipo do sabor
        </label>
        <select
          value={tipo}
          onChange={(event) =>
            onTipoChange(event.target.value as "doce" | "salgada")
          }
          className="w-full rounded-md border border-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="salgada">Salgada</option>
          <option value="doce">Doce</option>
        </select>
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Ingredientes
        </label>
        <CreatableSelect
          isMulti
          value={ingredientes.map((ingrediente) => ({
            value: ingrediente,
            label: ingrediente,
          }))}
          onChange={(options) => {
            const values = (options || []).map((option: SelectOption) =>
              option.value.trim()
            );
            onIngredientesChange(values.filter(Boolean));
          }}
          placeholder="Digite e pressione Enter para adicionar ingredientes"
          noOptionsMessage={() => "Digite um ingrediente e pressione Enter"}
          formatCreateLabel={(inputValue) => `Adicionar "${inputValue}"`}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Foto do sabor
        </label>
        <input
          type="file"
          accept="image/png,image/jpeg,image/webp"
          onChange={(event) => onFotoChange(event.target.files?.[0] ?? null)}
          className="w-full rounded-md border border-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {fotoUrl && (
          <div className="mt-2 flex items-center gap-3">
            <img
              src={fotoUrl}
              alt={`Foto do sabor ${nome}`}
              className="h-14 w-14 rounded-md object-cover"
            />
            <button
              type="button"
              onClick={onRemoverFoto}
              className="rounded-md border border-red-300 px-2 py-1 text-xs font-semibold text-red-700 hover:bg-red-50"
            >
              Remover foto
            </button>
          </div>
        )}
      </div>

      <FormActions onCancel={onCancel} isLoading={isSaving} />
    </form>
  );
};

export default CardapioForm;
